import { render, staticRenderFns } from "./Pdfvuer.vue?vue&type=template&id=2b89982c"
import script from "./Pdfvuer.vue?vue&type=script&lang=js"
export * from "./Pdfvuer.vue?vue&type=script&lang=js"
import style0 from "pdfjs-dist/web/pdf_viewer.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports